import React from 'react';
import { connect } from 'react-redux';

import {
  getOpenedTask,
  getOpenedTaskCreatedAt,
  getOpenedTaskCreatedBy,
} from '../../../../../redux/tasks/taskEntities/selectors';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGetProjectFormsQuery } from '../../../../../services/formsApi';

const TaskDetailsCreatedBy = ({
  allUsers,
  createdAt,
  createdBy,
  deactivated,
  task,
}) => {
  const intl = useIntl();

  const { data: forms } = useGetProjectFormsQuery({
    projectId: task?.projectId,
  }, { skip: !task?.projectId });

  const date = new Date(createdAt);
  const taskCreationTime = intl.formatDate(date, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  let createdByLabel = '';

  if (createdBy !== 'Form') {
    createdByLabel =
      allUsers?.find((member) => member?._id === createdBy)?.fullName || '-';
  } else {
    const formName = forms?.data?.find(
      (f) => f?._id === task?.sourceId,
    )?.formTitle;
    createdByLabel =
      formName ||
      intl.formatMessage({
        id: 'FORM_SUBMISSION',
        defaultMessage: 'Form',
      });
  }

  if (createdBy === '-') {
    const user = deactivated?.find(
      (member) => member?._id === createdBy,
    )?.fullName;
    createdByLabel = user ? user + ' (deactivated)' : '---';
  }
  return (
    <div className="ml-3 font-14 mt-2 mb-8 flex text-gray-400 items-center">
      <FormattedMessage
        id="CREATED_BY_WHOM_AND_WHEN"
        defaultMessage="Created by <div><span>{name}</span> on {date}</div>"
        values={{
          name: createdByLabel,
          date: taskCreationTime,
          span: (msg) => <div className="text-[#002337] mr-2">{msg}</div>,
          div: (msg) => <div className="ml-2  flex items-center ">{msg}</div>,
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  allUsers: state.workspaceReducer.currentWorkspace.members,
  createdAt: getOpenedTaskCreatedAt(state),
  createdBy: getOpenedTaskCreatedBy(state),
  task: getOpenedTask(state),
  deactivated: state.workspaceReducer.currentWorkspace.deactivated,
});

export default connect(mapStateToProps)(TaskDetailsCreatedBy);
